@if (certificate) {
  <div
    class="certificate-card"
    [ngClass]="'layout-' + layout"
    [attr.data-cy]="'certificate-card-' + certificate?.id"
    >
    <div class="certificate-card__body" (click)="openModal()">
      @if (layout === 'regular') {
        <div
          class="certificate-card__body--image"
          [cropImage]="certificate?.customCertificate?.mediaImage | preSignedUrl | async"
          [additionalOptions]="{width: 200}" >
          <div class="certificate-card__body--status"></div>
        </div>
      } @else {
        <div class="certificate-card__body--icon">
          <lib-icon icon="certificate" size="32"></lib-icon>
        </div>
      }
      <div class="certificate-card__body--title-wrapper">
        <div class="certificate-card__body--title"  data-cy="certificate-card-title">
          {{certificate.title}}
        </div>
        @if (certificate.dateOfCompletion) {
          <div class="certificate-card__body--subtitle" data-cy="certificate-card-completion-date">
            {{'COMMON.granted' | translate}} {{certificate.dateOfCompletion | customDate}}
          </div>
        }
      </div>
    </div>
    <div class="certificate-card__buttons" (click)="$event.stopPropagation()">
      <button mat-icon-button class="button button--icon" (click)="preview()" data-cy="certificate-card-preview-button">
        <lib-icon icon="eye"></lib-icon>
      </button>
      @if (shareEnabled) {
        <button mat-icon-button class="button button--icon" (click)="share()" data-cy="certificate-card-share-button">
          <lib-icon icon="share-network"></lib-icon>
        </button>
      }
      <button mat-icon-button class="button button--icon" (click)="download()" data-cy="certificate-card-download-button">
        @if (!isDownloading) {
          <lib-icon icon="download-simple"></lib-icon>
        } @else {
          <mat-spinner diameter="24"></mat-spinner>
        }
      </button>
    </div>
    <div class="certificate-card__more">
      <button mat-icon-button class="button button--icon button--icon-extra-small" [matMenuTriggerFor]="certificateMenu">
        <lib-icon icon="dots-three-vertical"></lib-icon>
      </button>
      <mat-menu #certificateMenu="matMenu" class="base-context-menu">
        @if (false) {
          <button mat-menu-item class="base-menu-button" aria-label="Preview" (click)="open()">
            <lib-icon icon="eye"></lib-icon> {{'COMMON.preview' | translate}}
          </button>
        }
        @if (shareEnabled) {
          <button mat-menu-item class="base-menu-button"aria-label="Share" (click)="share()">
            <lib-icon icon="share-network"></lib-icon> {{'COMMON.share' | translate}}
          </button>
        }
        <button mat-menu-item class="base-menu-button" aria-label="Download" (click)="download()">
          <lib-icon icon="download-simple"></lib-icon> {{'COMMON.download' | translate}}
        </button>
      </mat-menu>
    </div>
  </div>
}
